var chunkMapping = {
	"124": [
		20124
	],
	"202": [
		78202
	],
	"276": [
		95276
	],
	"412": [
		99412
	],
	"449": [
		31449
	],
	"507": [
		12507
	],
	"696": [
		62696
	]
};
var idToExternalAndNameMapping = {
	"12507": [
		"default",
		"./App",
		22575
	],
	"20124": [
		"default",
		"./App",
		45659
	],
	"31449": [
		"default",
		"./App",
		47498
	],
	"62696": [
		"default",
		"./App",
		53510
	],
	"78202": [
		"default",
		"./App",
		94482
	],
	"95276": [
		"default",
		"./Widget",
		47498
	],
	"99412": [
		"default",
		"./UpsellWidget",
		53510
	]
};
var idToRemoteMap = {
	"12507": [
		{
			"externalType": "script",
			"name": "user_management_frontend",
			"externalModuleId": 22575
		}
	],
	"20124": [
		{
			"externalType": "script",
			"name": "poiManagement",
			"externalModuleId": 45659
		}
	],
	"31449": [
		{
			"externalType": "script",
			"name": "wizardGenerator",
			"externalModuleId": 47498
		}
	],
	"62696": [
		{
			"externalType": "script",
			"name": "dashboardGeneratorVisualizer",
			"externalModuleId": 53510
		}
	],
	"78202": [
		{
			"externalType": "script",
			"name": "onedsp",
			"externalModuleId": 94482
		}
	],
	"95276": [
		{
			"externalType": "script",
			"name": "wizardGenerator",
			"externalModuleId": 47498
		}
	],
	"99412": [
		{
			"externalType": "script",
			"name": "dashboardGeneratorVisualizer",
			"externalModuleId": 53510
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}